import KupynaHasher from '@/components/KupynaHasher';

export default function App() {
  return (
    <div
      className="min-h-screen flex items-center justify-center p-4"
      style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}
    >
      <KupynaHasher />
    </div>
  );
}
